import React from 'react';
import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';

import { InsuredAmountContainer } from '../insured-amount/container';
import { useInsuranceCheckbox } from '../../hooks/use-insurance-checkbox';

import { messages } from './messages';
import style from './style.module.css';

export const InsuranceCheckboxWithLabel = () => {
  const {
    containsSupportedDestinationError,
    hasInsuranceProviderSelected,
    INSURANCE_CHECKBOX_ID,
    isChecked,
    isWalletedInsuranceEligible,
    onCheckboxChange,
  } = useInsuranceCheckbox();

  return (
    <React.Fragment>
      <label className={style.label} htmlFor={INSURANCE_CHECKBOX_ID}>
        <FormattedMessage {...messages.insureForHeader} />
      </label>
      <div className={style['insurance-container-group']}>
        <Checkbox
          checked={isChecked}
          className={style['insurance-checkbox']}
          disabled={!isWalletedInsuranceEligible || containsSupportedDestinationError}
          inputId={INSURANCE_CHECKBOX_ID}
          onChange={onCheckboxChange}
        />
        <InsuredAmountContainer
          className={classnames(style['insurance-amount'], style['checkbox-input'])}
          disabled={!hasInsuranceProviderSelected}
        />
      </div>
      <div />
      {containsSupportedDestinationError && (
        <div className={style['insurance-not-available']}>
          <FormattedMessage {...messages.insuranceNotAvailable} />
        </div>
      )}
    </React.Fragment>
  );
};
